import React, { useEffect, useState } from "react";
import { EventResolveStatus, Level, ListSystemEventLogsRequest } from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { SystemEventService } from "../../services/SystemEventService";
import { ColumnType } from "../list/list/ColumnType";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { ListUtils } from "../list/list/ListUtils";
import { PagerModel } from "../list/list/PagerModel";

interface Props {
    userId : number;
}
interface State {
    listRequest? : ListSystemEventLogsRequest;
}

const SystemEventView: React.FC<Props> = (props: Props) => {
    const systemEventService = getContainer().getSystemEventService();
    const [userId, setUserId] = useState(props.userId);
    const [date, setDate] = useState(new Date());
    const [startOfLastMonth, setStartOfLastMonth] = useState(new Date(new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0, 10)));
    const [listRequest, setListRequest] = useState<ListSystemEventLogsRequest>({limit: 50, offset: 0, userId: props.userId, resolved: EventResolveStatus.NOT_RESOLVED, level: Level.ERROR, startDate: startOfLastMonth, endDate: date})
    const [lookupExpanded, setLookupExpanded] = useState(true);

    const columns = [
        {property: "id", name: "ID"},
        {property: "timestamp", name: "Timestamp", type: ColumnType.DATE},       
        {property: "subType", name: "Type"},
        {property: "level", name: "Level"},
        {
            property: "resolved", name: "Resolved",
            renderer: (property: string, name: string, item: any) => {
                let backgroundColor = '#F1556C';
                if (item["resolved"]) {
                    backgroundColor = '#28A745';
                }
                const backgroundColorCSS = {
                    backgroundColor: backgroundColor
                };

                return <span style={backgroundColorCSS} className={"dot"}/>
            }
        }
    ];
    
    const pagerChanged = (pager : PagerModel) => {
        if(!listRequest) {
            return;
        }
        var listRequestNew:ListSystemEventLogsRequest = ListUtils.toListRequest<ListSystemEventLogsRequest>(listRequest, pager);
        setListRequest(listRequestNew);
    }

    useEffect(() => {
        setListRequest({limit: 50, offset: 0, userId: props.userId, resolved: EventResolveStatus.NOT_RESOLVED, level: Level.ERROR});        
        setUserId(props.userId);
    },[props.userId]);    

        return (
               <div className={"card-box expandable-box"}  style={!lookupExpanded ? {cursor:"pointer"} : {cursor:"default"}} onClick={() => !lookupExpanded ? setLookupExpanded(true) : null}>
            {lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault(); setLookupExpanded(false);}}><i className="mdi mdi-minus"></i></a>
                )}
                {!lookupExpanded && (
                    <a href="/#" className="expand-button float-right" onClick={(e:any)=>{ e.preventDefault();setLookupExpanded(true);}}><i className="mdi mdi-plus"></i></a>
                )}
                    <div className="" onClick={()=>setLookupExpanded (!lookupExpanded)}>
                        <h4>System Event</h4>
                    </div>
            {lookupExpanded && ( 
                <EntityDataTable
                    columns={columns}
                    service={systemEventService}
                    listRequest={listRequest}
                    onPagerChange={pagerChanged.bind(this)}
                    onAction={()=>undefined}
                />
                    )}
           </div>
        )
    }

    export default SystemEventView;
